export default __webpack_public_path__ + "static/media/oxygen-orange.c0bceaec.svg";